'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import { leadership } from './content'

const AboutLeadership = () => {
  const translate = useTranslate('about_mission.leadership')
  const aboutAsset = useAsset('/assets/about')

  const renderLeadershipCard = ([name, status]: Array<string>) => (
    <div className="about__leadership-card" key={name}>
      <Image src={aboutAsset(`${name!}.jpg`)} scaling="contain" />
      <div className="about__leadership-card__info">
        <h5 className="landing__entry-title">{translate(`${status!}.title`)}</h5>
        <p className="landing__entry-body">{translate(`${status!}.subtitle`)}</p>
      </div>
    </div>
  )

  return (
    <>
      <Spacer size="x4-large" />
      <div className="u-tablets-up-only">
        <Spacer size="x4-large" />
      </div>
      <div className="about__section">
        <Text alignment="left" as="h2">
          <span className="c-text--responsive-large-heading">{translate('title')}</span>
        </Text>
        <Spacer size="x2-large" />
        <div className="u-tablets-up-only">
          <Spacer size="x2-large" />
        </div>
        <div className="landing__slider-wrapper">
          <div className="about__leadership-slider">{leadership.map(renderLeadershipCard)}</div>
        </div>

        <Spacer size="x4-large" />
        <Text alignment="left" as="p">
          <span
            className="c-text--responsive-small-body"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: translate('text') }}
          />
        </Text>
      </div>
    </>
  )
}

export default AboutLeadership
